import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Mail, ExternalLink, Facebook } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/40 bg-background/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://customer-assets.emergentagent.com/job_webbie-hub/artifacts/h9gsks62_Cogsmith-logo.png"
                alt="Cogsmith Logo"
                className="h-8 w-8"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-purple-400 via-purple-500 to-yellow-400 bg-clip-text text-transparent">
                Cogsmith
              </span>
            </div>
            <p className="text-sm text-foreground/60">
              AI Desktop Assistant for the Web and Tools
            </p>
            <div className="flex space-x-4">
              <a
                href="https://twitter.com/CogSmithApp"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/60 hover:text-purple-400 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61582552267596"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/60 hover:text-purple-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="mailto:info@cogsmith.ai"
                className="text-foreground/60 hover:text-purple-400 transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-foreground">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/features"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/download"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Download
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-foreground">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/docs"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-foreground">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-foreground/60 hover:text-purple-400 transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border/40">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-foreground/60">
              © {currentYear} Cogsmith. Buy once, keep forever.
            </p>
            <p className="text-sm text-foreground/60">
              Built with ❤️ for developers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;